export const FR_HEADER_HEIGHT = 84;
export const FR_EMERGENCY_BANNER_INCLUDED_HEIGHT = 140;
export const MAX_NOTIFICATIONS_COUNT = 9;
export const FR_FOOTER_HEIGHT = 80;
